"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CostManagementItemType;
(function (CostManagementItemType) {
    CostManagementItemType[CostManagementItemType["Inventory"] = 1] = "Inventory";
    CostManagementItemType[CostManagementItemType["Rented"] = 2] = "Rented";
})(CostManagementItemType || (CostManagementItemType = {}));
exports.default = CostManagementItemType;
